import { AccordionPanel, AccordionPanelProps } from '@chakra-ui/accordion';
import React from 'react';

export const CmAccordionPanel: React.FC<AccordionPanelProps> = ({
  children,
  ...rest
}) => {
  // @ts-ignore TS2590
  return <AccordionPanel {...rest}>{children}</AccordionPanel>;
};
